/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeRequestsStatisticsReportDTO
 */
export interface ChangeRequestsStatisticsReportDTO {
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestsStatisticsReportDTO
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChangeRequestsStatisticsReportDTO
     */
    numberOfSpots?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeRequestsStatisticsReportDTO
     */
    remainingSpots?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeRequestsStatisticsReportDTO
     */
    numberOfStudentsAccepted?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeRequestsStatisticsReportDTO
     */
    numberOfStudentsLeaving?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeRequestsStatisticsReportDTO
     */
    numberOfRequestsToChangeSubject?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeRequestsStatisticsReportDTO
     */
    numberOfRequestsToTakeSubject?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeRequestsStatisticsReportDTO
     */
    enrolledStudents?: number;
}

export function ChangeRequestsStatisticsReportDTOFromJSON(json: any): ChangeRequestsStatisticsReportDTO {
    return ChangeRequestsStatisticsReportDTOFromJSONTyped(json, false);
}

export function ChangeRequestsStatisticsReportDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestsStatisticsReportDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'numberOfSpots': !exists(json, 'numberOfSpots') ? undefined : json['numberOfSpots'],
        'remainingSpots': !exists(json, 'remainingSpots') ? undefined : json['remainingSpots'],
        'numberOfStudentsAccepted': !exists(json, 'numberOfStudentsAccepted') ? undefined : json['numberOfStudentsAccepted'],
        'numberOfStudentsLeaving': !exists(json, 'numberOfStudentsLeaving') ? undefined : json['numberOfStudentsLeaving'],
        'numberOfRequestsToChangeSubject': !exists(json, 'numberOfRequestsToChangeSubject') ? undefined : json['numberOfRequestsToChangeSubject'],
        'numberOfRequestsToTakeSubject': !exists(json, 'numberOfRequestsToTakeSubject') ? undefined : json['numberOfRequestsToTakeSubject'],
        'enrolledStudents': !exists(json, 'enrolledStudents') ? undefined : json['enrolledStudents'],
    };
}

export function ChangeRequestsStatisticsReportDTOToJSON(value?: ChangeRequestsStatisticsReportDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'numberOfSpots': value.numberOfSpots,
        'remainingSpots': value.remainingSpots,
        'numberOfStudentsAccepted': value.numberOfStudentsAccepted,
        'numberOfStudentsLeaving': value.numberOfStudentsLeaving,
        'numberOfRequestsToChangeSubject': value.numberOfRequestsToChangeSubject,
        'numberOfRequestsToTakeSubject': value.numberOfRequestsToTakeSubject,
        'enrolledStudents': value.enrolledStudents,
    };
}

